import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import QueryRequest from '../../QueryRequest';

export const SEARCH_CONTENT_GROUP_REQUEST = gql`
  query searchSliderConfRequest(
    $projectId: String!
    $configurationName: String!
  ) {
    questionConfiguration {
      searchSliderConfiguration(
        projectId: $projectId
        configurationName: $configurationName
      ) {
        defaultValue
        description
        id
        maxValue
        minValue
        step
        ticks {
          label
          sliderValue
        }
      }
    }
  }
`;

const searchSliderConfRequest = ({
  projectId,
  configurationName,
  onError,
  onSuccessResult,
}) => (
  <Query
    fetchPolicy="network-only"
    query={SEARCH_CONTENT_GROUP_REQUEST}
    variables={{ projectId, configurationName }}
  >
    {({ error, data }) => (
      <QueryRequest
        data={
          data &&
          Object.entries(data).length !== 0 &&
          data.questionConfiguration.searchSliderConfiguration
        }
        error={error}
        onError={onError}
        onSuccessResult={onSuccessResult}
      />
    )}
  </Query>
);

searchSliderConfRequest.propTypes = {
  configurationName: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
};

export default searchSliderConfRequest;
